import { ReactNode } from 'react'
import { AvailableItems } from './cartTypes'
import { OptionsTypes } from './enhancementTypes'
import { Esthetician, TimeSlot } from './estheticianTypes'
import {
  Address,
  AnalyticsLocationData,
  ConfirmationScreenPromo,
  ContactInfo,
} from './locationTypes'
import { ServiceContent } from './maliblePageTypes'
import { MembershipType, Tag } from './membershipTypes'
import { CartOffer } from './promoCodeTypes'
import {
  BookedAppointmentResponse,
  MembershipsEdge,
  MembershipVoucher,
} from './userTypes'

type FacialServiceType = Facial & ServiceContent

export interface Location {
  locationId: string
  name: string
  tz: string
  mapImg: string
  openDate?: string
  advanceBookingLimit: number
  enableGroupBooking: boolean
  enableGhostBooking: boolean
  enableMembershipFlow: boolean
  address: Address
  contact: ContactInfo
  enableNewClientPromo: boolean
  confirmationScreenPromo: ConfirmationScreenPromo
  tier: string
}

export interface CartSummary {
  discountAmount: number
  gratuityAmount: number
  paymentMethodRequired: boolean
  subtotal: number
  taxAmount: number
  total: number
  depositAmount: number
  deposit: string
}

interface Cart {
  cartId: string
  cartValue: number
  summary: CartSummary
  isPromoCodeApplied: boolean
  promoCodes: CartOffer[]
  appointmentId: string
  purchasedMembership: boolean
}

interface Category {
  categoryId: string
  categoryObj?: AvailableItems
}

export interface JwtTokenPayload {
  id: string
  customer_access_token: string
  boulevard_id: string
  shopify_id: string
  iat: number
  exp: number
}

interface User {
  token: string | null
}

export interface Enhancement {
  id: string
  name: string
  description: string
  listPrice: number
  cartItemId?: string
  newLabel?: boolean
  borderColor: string
  order?: number
  newLabelText?: string
  icon?: ReactNode
  helpText?: string
  addon?: boolean
  limitedEdition?: boolean
  titleVisible?: string
  bannerBg?: string
}

export interface UserInfo {
  first_name: string
  last_name: string
  email: string
  phone_number: string
  is_member: boolean
  tags: Tag[]
  boulevard_id: string
  membership_start_on: string
  membership_agreement: boolean
  membership_agreement_time?: Date
  mobileNumber?: string
  isSMSOptInChecked?: boolean
  completed_appointment_count?: number | null
}

export interface Addon {
  id: string
  name: string
}

export interface Facial {
  id: string
  name: string
  listPrice: number
}

export interface AppData {
  location: Location
  cart: Cart
  enhancementOptionId: string
  category: Category
  email: string
  selectedEnhancements: Enhancement[] | OptionsTypes[]
  membershipVouchers: MembershipVoucher[]
  selectedDate: Date
  selectedEsthetician: Esthetician
  selectedTime: TimeSlot
  selectedFacial: string
  selectedService: FacialServiceType
  availableFacials: Facial[]
  availableEnhancements: Enhancement[] | OptionsTypes[]
  availableEstheticians: Esthetician[]
  membershipData: AvailableItems
  userMembershipType: MembershipType
  userActiveMembership: MembershipsEdge | null
  enhancement: boolean
  isLoggedIn: boolean
  isAgree: boolean
  user: User
  userTokenPayload: JwtTokenPayload
  userInfo: UserInfo
  filteredEstheticians: Esthetician[]
  previousBookedAppointments: BookedAppointmentResponse[]
  loginEmail: string
  isLaserFacial: boolean
  isMicroNeedling: boolean
  isUTMExist: boolean
  utmSource?: string | null
  referCode?: string | null
  addons?: Addon[]
}

export interface FallBackData {
  location: AnalyticsLocationData
  is_promo_code_applied: boolean
  selected_esthetician: Esthetician
  enhancement: boolean
  is_loggedIn: boolean
  user_info: UserInfo | null
}

export enum HeaderTheme {
  LIGHT = 'LIGHT',
  NEUTRAL_TERTIARY = 'NEUTRAL_TERTIARY',
  ORANGE = 'ORANGE',
  GREEN = 'GREEN',
}

export interface CustomContents {
  customer_status: string
}

export interface FacebookEvents {
  contents: CustomContents[]
  content_type: string
  content_name: string
  category: string
  date: string | Date
  value: number
  num_items: number
  quantity: string
  currency: string
}

export type OrderUPF = {
  order_id: string
  order_name?: string
  amount?: number
  items: {
    name: string
    amount: number
    currency: string
  }[]
  customer: {
    customer_id: string
    first_name: string
    last_name: string
    email: string
  }
}
